<template>
  <div>
    <loader/>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import Loader from '@/components/template/Loader'

  export default {
    async mounted () {
      await this.login()
      this.$router.push('/')
    },
    methods: {
      ...mapActions('user', [
        'login'
      ])
    },
    components: {
      Loader
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Base.vue?3971e627